import { createIcon } from '../create-icon'

// Heart with pulse line — toughness and staying alive
export const GpiSurvivability = createIcon('GpiSurvivability', ({ strokeWidth }) => (
  <>
    <path d="M19.5 12.572l-7.5 7.428l-7.5-7.428A5 5 0 0 1 12 6.006a5 5 0 0 1 7.5 6.572" strokeWidth={strokeWidth} />
    <path d="M5 12h2l2-3 3 6 2-3h5" strokeWidth={strokeWidth} />
  </>
))
